export default __webpack_public_path__ + "static/media/portfolio_black.9dff1521.svg";